<template>
    <loading
        :is-full-page="true"
        :active.sync="isLoading"
        :opacity="0.95">
        <template v-slot:default>
            <div class="text-center">
                <img src="/images/logo.gif" alt="Logomarca Super Safra">
                <p class="text-uppercase" style="font-family: &quot;Libre Baskerville&quot;, serif; color: rgb(62, 64, 149); text-shadow: white 0.5px 0.5px 0.5px; letter-spacing: -4px; font-size: 20px; text-decoration: none;">
                    Grupo&nbsp; Super&nbsp;&nbsp; Safra&nbsp;&nbsp;
                </p>
            </div>
        </template>
    </loading>
</template>

<script>
    // Import component
    import Loading from 'vue-loading-overlay';
    // Import stylesheet
    import 'vue-loading-overlay/dist/vue-loading.css';
    export default {
        data(){
            return {
                isLoading: false,
            }
        },
        mounted() {
            $('#loginForm').on('submit', () => {
                this.$Progress.start();
                this.isLoading = true;
                return true;
            });
        },
        components: {
            'loading': Loading
        }
    }
</script>
